package com.parmartechnologies.commerce.feature.inventory.brand.viewmodel

import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.core.feature.inventory.brand.model.Brand
import com.parmartechnologies.core.feature.inventory.brand.network.CreateBrandRequest
import com.parmartechnologies.core.feature.inventory.brand.network.RetrieveBrandRequest
import com.parmartechnologies.core.feature.inventory.brand.network.UpdateBrandRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.inventory.brand.handler.BrandHandler
import com.parmartechnologies.commerce.feature.inventory.brand.network.BrandNetwork
import com.parmartechnologies.commerce.feature.inventory.brand.repository.BrandRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.storage.table.inventory.brand.BrandDatabaseTable
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class BrandViewModel(val business: Business, val repository: BrandRepository = BrandHandler.shared().repository) :
    AppViewModel() {

    val allBrand: StateFlow<List<Brand>>
        get() = repository.brandLiveData

    val selectedBrand: StateFlow<Brand?>
        get() = repository.selectedBrand

    val editBrand: StateFlow<Brand?>
        get() = repository.editBrand

    val brandsState: MutableStateFlow<List<Brand>> = MutableStateFlow(arrayListOf())

    val brands: StateFlow<List<Brand>>
        get() = brandsState

    fun fetchAllBrand() {
        loadFromStorage()
        if (allBrand.value.isEmpty()) {
            val request =
                RetrieveBrandRequest(business._id)
            // startLoading()
            scope.launch {
                BrandNetwork().retrieve(request) {
                    stopLoading()
                    BrandDatabaseTable().insert(it?.payload)
                    loadFromStorage()
                }
            }
        }
    }

    fun loadAllBrand() {
        fetchAllBrand()
    }

    private fun loadFromStorage() {
        BrandDatabaseTable().retrieveAll(business._id) { data ->
            scope.launch {
                repository.brandLiveData.emit(data)
            }
        }
    }

    fun createNewBrand(name: String, description: String, completion: () -> Unit) {
        val request = CreateBrandRequest(
            name,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            BrandNetwork().create(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allBrand: MutableList<Brand> =
                            repository.allBrand.value.toMutableList()
                        allBrand.add(it.payload!!)
                        repository.brandLiveData.emit(allBrand)
                        BrandDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }

    fun updateBrand(name: String, id: String, description: String, completion: () -> Unit) {
        val request = UpdateBrandRequest(
            name,
            id,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            BrandNetwork().update(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allBrand: MutableList<Brand> =
                            repository.allBrand.value.toMutableList()
                        allBrand.add(it.payload!!)
                        repository.brandLiveData.emit(allBrand)
                        BrandDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }
}